// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"00ab324a","298":"00ab324a","605":"8c2eccc3"}[chunkId] + ".chunk.css";
};